import { EdgeLoadConfigRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadConfig } from '@/modules/auth/use-cases'

export function makeLoadConfig(): LoadConfig {
  return new EdgeLoadConfigRepository(makeSupabaseEdgeHttpClient()).execute
}
